import CustomDot from './CustomDot';
import { APIProvider, Map,AdvancedMarker } from '@vis.gl/react-google-maps';

const GoogleMap = ({ initialMarkers,liveDotPosition,center }) => {
  
return(
   
     <div style={{ 
                height: '1000px', 
                width: '100%', 
                padding: '10px',
                fontFamily: 'Inter, sans-serif'
            }}> 

            {initialMarkers.length === 0 ? null : (
                <div style={{ height: '70%', width: '100%', borderRadius: '12px', overflow: 'hidden' }}>
                    <APIProvider apiKey={window.config.GMAP_API}>
                        <Map
                            defaultCenter={center}
                            defaultZoom={11}  
                            mapId="DEMO_MAP_ID"
                            gestureHandling={'greedy'} 
                        >  
                            
                            {initialMarkers.map((marker) => (
                                    <AdvancedMarker 
                                        key={marker.id} 
                                        position={{ lat: marker.lat, lng: marker.lng }} 
                                        title={marker.title} 
                                    >  
                                     {marker.serviced ?(<CustomDot color={'#d8dce0ff'} size={'16px'} isFlashing={false} />) : (<CustomDot color={'#1E90FF'} size={'16px'} isFlashing={false} />)}
                                    </AdvancedMarker>
                                ))
                            } 

                            {Object.keys(liveDotPosition).length > 0 ? (
                                <AdvancedMarker 
                                    key={liveDotPosition.id} 
                                    position={{ lat: liveDotPosition.lat, lng: liveDotPosition.lng }} 
                                    title={liveDotPosition.unitlabel}
                                >  
                                    <CustomDot color={'#FF0000'} size={'18px'} isFlashing={true} label={liveDotPosition.unitlabel} /> 
                                </AdvancedMarker>
                            ) : null}
                              
                        </Map>
                    </APIProvider>
                </div> 
                  )} 
            </div>   
           
)
}

export default GoogleMap;